import React, { useEffect, useState } from 'react'
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material'
import { CheckboxComponent, TextFieldComponent } from '../../components/CustomFormElement'
import validators from '../../utils/validators';
import { makeStyles } from '@mui/styles';
import { ErrorIcon, InformPasswordIcon, SuccessIcon } from '../../components/CustomIcons';
import theme from '../../theme.css';
import CustomUploadFile from '../../components/CustomUploadFile';
import PaymentMethod from '../../components/PaymentMethod';
import CustomSection from '../../components/CustomSection';
import CustomHeader from '../../components/CustomHeader'
import CustomDivider from '../../components/CustomDivider'
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import CustomCircularProgress from '../../components/CustomCircularProgress';
import CustomAlerts from '../../components/CustomAlerts';
import { paths } from '../../config/router.config';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../components/CustomAlert';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
    },
    link: {
        color: theme.palette.text.link,
        textDecoration: 'none',
    },
    button: {
        textTransform: 'capitalize!important'
    },
    check_box: {
        padding: 0,
    },
    inform: {
        cursor: 'pointer',
    },
    inform_password: {
        position: 'relative',
    },
    inform_password_desc: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
        // marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3),
        border: '1px solid ' + theme.palette.border.secondary,
        position: 'absolute',
        zIndex: 10,
        right: 0,
    },
    text_center: {
        textAlign: 'center',
    },
}));

export default function RegisterView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const { onSameHomeAddress, isSameHomeAddress, payment_selected, address, validations, onCheckEmail, showLoadingEmail, focusField, registerInfo } = props;

    console.log("validations===", validations);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <Grid xs={12} item>
            {/* <CustomHeader hideSignIn /> */}
            <Grid xs={12} item container justifyContent='center' className={classes.content}>
                {/* <input name="email" type="text"/> */}
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <Grid xs={12} item container justifyContent='center'>
                            <Typography variant='h1' color='primary'>{t('registration')}</Typography>
                        </Grid>
                        <Grid xs={12} item container justifyContent='center' marginTop={1}>
                            <Typography variant='p' color='primary'>{t('registration_desc')}</Typography>
                        </Grid>
                        <Grid xs={12} item container justifyContent='center' marginTop={2}>
                            <CustomDivider />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} item container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <Form
                            onSubmit={props.onSubmit}
                            initialValues={{
                                ...address,
                                apartment_name: address && address.mdu_name ? address.mdu_name : null,
                                apartment_number: address && address.mdu_unitno ? address.mdu_unitno : null,
                                town_city: address && address.city ? address.city : null,
                                state_province_county: address && address.province ? address.province : null,
                                ...registerInfo,
                                email_address: registerInfo && registerInfo.email ? registerInfo.email : null,
                                mobile_number: registerInfo && registerInfo.phone_number ? registerInfo.phone_number : null,
                                confirm_password: registerInfo && registerInfo.password ? registerInfo.password : null,
                            }}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify="center" alignItems="center">
                                    <PersonalDetails t={t} classes={classes}
                                        validations={validations}
                                        showLoadingEmail={showLoadingEmail}
                                        values={values}
                                        focusField={focusField}
                                        registerInfo={registerInfo}
                                        onHandleUpload={props.onHandleUpload}
                                        onCheckEmail={onCheckEmail}
                                        onHandleBlur={props.onHandleBlur}
                                        onAddImage={props.onAddImage}
                                    />
                                    <HomeRICAAddress t={t} classes={classes} address={address} />
                                    {/* <DeliveryAddress t={t} classes={classes}
                                        isSameHomeAddress={isSameHomeAddress}
                                        onSameHomeAddress={onSameHomeAddress}
                                    /> */}
                                    {/* <CustomSection
                                        title={t('choose_payment_method')}
                                    >
                                        <PaymentMethod onChangePayment={props.onChangePayment} payment_selected={payment_selected} />
                                    </CustomSection> */}
                                    {/* <BillPayment t={t}
                                        options={props.options}
                                        selected={props.selected}
                                        onChangeOption={props.onChangeOption}
                                    /> */}
                                    {/* <AgreeTerm t={t} setAgreeTerm={props.setAgreeTerm} isAgreeTerm={props.isAgreeTerm}/> */}
                                    <Grid xs={12} paddingTop={5} item>
                                        <Grid item xs={12} textAlign='center'>
                                            <Button variant="contained" color="primary" onClick={() => history.push(paths.package_info)} className={classes.button}>{t('btn_back')}</Button>
                                            <Button variant="contained" color="primary" onClick={handleSubmit} className={classes.button} style={{ marginLeft: 10 }}>{t('btn_proceed')}</Button>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid xs={12} item marginTop={5} style={{textAlign: 'center'}}>
                        <Link to={paths.login} className={classes.link} fullWidth>
                            {t('back_to_signin')}
                        </Link>
                    </Grid> */}
                                </Grid>
                            )} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

function PersonalDetails(props) {
    const { t, classes, validations, onCheckEmail, showLoadingEmail, values, focusField, registerInfo } = props;
    const [showInform, setShowInform] = useState(false);
    console.log("registerInfo ===", registerInfo);

    return (
        <CustomSection
            title={t('persional_details')}
        >
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="first_name"
                        component={TextFieldComponent}
                        placeholder={t('first_name') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="last_name"
                        component={TextFieldComponent}
                        placeholder={t('last_name') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="email_address"
                        component={TextFieldComponent}
                        placeholder={t('email_address') + '*'}
                        // autoFocus={focusField && focusField.email}
                        validate={validators.composeValidators(validators.required)}
                        onCustomOnBlur={(email) => onCheckEmail(email)}
                        endAdornment={showLoadingEmail === true ? <CustomCircularProgress /> : validations && validations.email === true ? <ErrorIcon /> : (validations.email === false && <SuccessIcon />)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="mobile_number"
                        component={TextFieldComponent}
                        placeholder={t('mobile_number') + ', eg: 0812345674*'}
                        validate={validators.composeValidators(validators.mustBeNumberRequired)}
                        onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'phone')}
                        endAdornment={validations && validations.phone === true ? <ErrorIcon /> : (validations.phone === false && <SuccessIcon />)}
                    // meta={{
                    //     touched: validations && validations.phone,
                    //     error: t('must_be_phone_length')
                    // }}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item>
                <Field
                    fullWidth
                    name="password"
                    component={TextFieldComponent}
                    placeholder={t('password') + '*'}
                    type="password"
                    validate={validators.composeValidators(validators.required, validators.validNotMatch({ compareValue: values.password, message: t('enter_same_password') }, values.confirm_password))}
                    onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'password')}
                    endAdornment={validations && validations.password === true ? <ErrorIcon /> : (validations && validations.password === false ? <SuccessIcon /> : null)}
                // meta={{
                //     touched: validations && validations.password,
                //     error: t('must_be_password_length')
                // }}
                />
            </Grid>
            <Grid xs={12} item container spacing={2} alignItems='center' justifyContent={'center'}>
                <Grid item xs={11}>
                    <Field
                        fullWidth
                        name="confirm_password"
                        component={TextFieldComponent}
                        placeholder={t('confirm_password') + '*'}
                        type="password"
                        validate={validators.composeValidators(validators.required, validators.validNotMatch({ compareValue: values.password, message: t('enter_same_password') }, values.confirm_password))}
                        onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'confirm_password')}
                        endAdornment={validations && validations.confirm_password === true ? <ErrorIcon /> : (validations.confirm_password === false ? <SuccessIcon /> : null)}
                    // meta={{
                    //     touched: validations && validations.confirm_password,
                    //     error: t('must_be_password_length')
                    // }}
                    />
                </Grid>
                <Grid item xs={1}>
                    <InformPasswordIcon onMouseEnter={() => setShowInform(true)} onMouseLeave={() => setShowInform(false)} />
                </Grid>
            </Grid>
            {showInform && <Grid item xs={12} className={classes.inform_password}>
                <Grid item className={classes.inform_password_desc}>
                    <Typography color='error'>{t('inform_password')}</Typography>
                    <Typography color='error'>{t('inform_password_1')}</Typography>
                    <Typography color='error'>{t('inform_password_2')}</Typography>
                    <Typography color='error'>{t('inform_password_3')}</Typography>
                    <Typography color='error'>{t('inform_password_4')}</Typography>
                    {/* <Typo color='error'>{t('inform_password_5')}</Typo> */}
                </Grid>
            </Grid>}
            <Grid xs={12} item container alignItems='center' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Grid item xs={12} container alignItems='center'>
                        <Grid item xs={11}>
                            <Field
                                fullWidth
                                name="id_number"
                                component={TextFieldComponent}
                                placeholder={t('id_number')}
                                // validate={validators.composeValidators(validators.required)}
                                onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'id_number')}
                                endAdornment={validations && validations.id_number === true ? <ErrorIcon /> : (validations.id_number === false && <SuccessIcon />)}
                            // meta={{
                            //     touched: validations && validations.id_number,
                            //     error: t('must_be_id_number_length')
                            // }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Grid item className={classes.text_center}>
                                <Typography>{t('or')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="passport_number"
                        component={TextFieldComponent}
                        placeholder={t('passport_number')}
                    />
                </Grid>
            </Grid>
            {/* <Grid item xs={12} container direction='row' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Typography>{t('upload_id_passport_number')}</Typography>
                    <CustomUploadFile
                        name="file_id_passport_number"
                        id="file_id_passport_number"
                        desc={t('upload_id_passport_number')}
                        onUploadFile={(files) => props.onHandleUpload('file_id_passport_number', files)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography>{t('upload_proof_address')}</Typography>
                    <CustomUploadFile
                        name="file_proof_address"
                        id="file_proof_address"
                        desc={t('upload_proof_address')}
                        onUploadFile={(files) => props.onHandleUpload('file_proof_address', files)}
                    />
                </Grid>
            </Grid> */}
            <Grid item xs={12} >
                <CustomUploadFile
                    name="file_contact"
                    id="file_contact"
                    // buttonLabel={t('btn_add_image')}
                    desc={t('file_contact')}
                    onUploadFile={(files) => props.onAddImage('file_contact', files)}
                    isPreview={true}
                    isMulti={true}
                />
            </Grid>
        </CustomSection>
    );
}

function HomeRICAAddress(props) {
    const { t, classes, address } = props;
    console.log("address HomeRICAAddress===", address);

    return (
        <CustomSection
            title={t('home_rica_address')}
        >
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="street_number"
                        component={TextFieldComponent}
                        placeholder={t('address_streetnumber') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="street_name"
                        component={TextFieldComponent}
                        placeholder={t('address_streetname') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="town_city"
                        component={TextFieldComponent}
                        placeholder={t('address_towncity') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="postal_code"
                        component={TextFieldComponent}
                        placeholder={t('address_postalcode') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12}>
                    <Field
                        fullWidth
                        name="state_province_county"
                        component={TextFieldComponent}
                        placeholder={t('state_province_county') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="apartment_name"
                        component={TextFieldComponent}
                        placeholder={t('address_apartment_name')}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        fullWidth
                        name="apartment_number"
                        component={TextFieldComponent}
                        placeholder={t('address_apartment_number')}
                    />
                </Grid>
            </Grid>
        </CustomSection>
    );
}

function DeliveryAddress(props) {
    const { t, classes, isSameHomeAddress, onSameHomeAddress } = props;

    return (
        <CustomSection
            title={t('delivery_address')}
        >
            <Grid item xs={12}>
                <Grid item xs={12} style={{ textAlign: 'left' }}>
                    <Field
                        fullWidth
                        name="same_as_home_address"
                        component={CheckboxComponent}
                        label={t('same_as_home_address')}
                        changeCustom={true}
                        onChangeCustom={() => onSameHomeAddress()}
                        checked={isSameHomeAddress}
                        checkbox_custom={classes.check_box}
                    />
                </Grid>
            </Grid>
            {!isSameHomeAddress && <>
                <Grid xs={12} item container direction='row' spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <Field
                            fullWidth
                            name="delivery_street_number"
                            component={TextFieldComponent}
                            placeholder={t('address_streetnumber') + '*'}
                            validate={validators.composeValidators(validators.required)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Field
                            fullWidth
                            name="delivery_street_name"
                            component={TextFieldComponent}
                            placeholder={t('address_streetname') + '*'}
                            validate={validators.composeValidators(validators.required)}
                        />
                    </Grid>
                </Grid>
                <Grid xs={12} item container direction='row' spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <Field
                            fullWidth
                            name="delivery_town_city"
                            component={TextFieldComponent}
                            placeholder={t('address_towncity') + '*'}
                            validate={validators.composeValidators(validators.required)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Field
                            fullWidth
                            name="delivery_postal_code"
                            component={TextFieldComponent}
                            placeholder={t('address_postalcode') + '*'}
                            validate={validators.composeValidators(validators.required)}
                        />
                    </Grid>
                </Grid>
                <Grid xs={12} item>
                    <Field
                        fullWidth
                        name="delivery_apartment_name"
                        component={TextFieldComponent}
                        placeholder={t('address_apartment_name')}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        fullWidth
                        name="delivery_apartment_number"
                        component={TextFieldComponent}
                        placeholder={t('address_apartment_number')}
                    />
                </Grid>
            </>}
        </CustomSection>
    );
}

function BillPayment(props) {
    const { t, options, selected, onChangeOption } = props;

    return (
        <CustomSection
            title={t('choose_bill_payment')}
        >
            <CustomRadioButtonGroup
                items={options}
                selected={selected ? selected : null}
                onChange={onChangeOption}
            />
        </CustomSection>
    );
}

function AgreeTerm(props){
    const { t, isAgreeTerm, setAgreeTerm } = props;
    return (
        <Grid item xs={12} marginTop={4}>
            <Grid xs={12} item>
                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={isAgreeTerm} onChange={() => setAgreeTerm(!isAgreeTerm)}/>} label={t('agree_term_message')} />
                </FormGroup>
            </Grid>
        </Grid>
    );
}